import { splitProps } from 'solid-js';
import { Dynamic } from 'solid-js/web';
export const withAsProp = (Component) => {
    const ArkComponent = (props) => {
        const [localProps, otherProps] = splitProps(props, ['as']);
        return <Dynamic component={localProps.as || Component} {...otherProps}/>;
    };
    return ArkComponent;
};
function jsxFactory() {
    const cache = new Map();
    return new Proxy(withAsProp, {
        apply(target, thisArg, argArray) {
            return withAsProp(argArray[0]);
        },
        get(_, element) {
            const asElement = element;
            if (!cache.has(asElement)) {
                cache.set(asElement, withAsProp(asElement));
            }
            return cache.get(asElement);
        },
    });
}
export const ark = jsxFactory();
